var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"full-width fusion-body padrenostro",attrs:{"id":"recipeDescr"}},[_c('div',{staticClass:"container",staticStyle:{"flex-direction":"column"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.articleContent)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }